import { useState, useCallback } from 'react';

import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';

import { useRouter } from 'src/routes/hooks';

import { getNavigationPath } from 'src/utils/notification-router';

type ForegroundNotification = {
  title: string;
  body: string;
  data?: Record<string, string>;
};

export function NotificationHandler() {
  const router = useRouter();
  const [notification, setNotification] = useState<ForegroundNotification | null>(null);
  const [open, setOpen] = useState(false);

  const handleNotification = useCallback((event: any) => {
    const notif = event?.notification || event;
    setNotification({
      title: notif?.title || 'New Notification',
      body: notif?.body || '',
      data: notif?.data,
    });
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  const handleClick = useCallback(() => {
    if (notification?.data) {
      const path = getNavigationPath(notification.data);
      if (path) {
        router.push(path);
      }
    }
    setOpen(false);
  }, [notification, router]);

  return {
    handleNotification,
    snackbar: (
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={handleClose}
          severity="info"
          variant="filled"
          onClick={handleClick}
          sx={{ width: '100%', cursor: 'pointer' }}
        >
          {notification?.title}
          {notification?.body && ` - ${notification.body}`}
        </Alert>
      </Snackbar>
    ),
  };
}
